import { type ReactNode } from 'react'
import { useTheme } from 'styled-components'

import { ListingPrice } from '@/components/srp/listing-card/listing-price'
import { type ListingCardPrice } from '@/components/srp/listing-card/types'
import {
  RichCardHeaderContainer,
  RichCardLink,
  RichCardTitle,
  RichCardTitleWrapper,
} from '@/features/listing/components/rich-card/styled'

type RichCardHeaderProps = {
  price: ListingCardPrice
  title: string | ReactNode
  url: string
}

export const RichCardHeader = ({ price, title, url }: RichCardHeaderProps) => {
  const { colors } = useTheme()

  return (
    <RichCardHeaderContainer>
      <RichCardTitleWrapper>
        <RichCardTitle
          color={colors.grey.primary}
          data-testid="listing-title"
          forwardedAs="h3"
          size="medium"
        >
          <RichCardLink data-testid="rich-card-link" href={url}>
            {title}
          </RichCardLink>
        </RichCardTitle>
      </RichCardTitleWrapper>
      {price ? (
        <ListingPrice
          priceAmount={price.amount}
          priceOriginal={price.original}
          type={price.type}
          surcharges={price.surcharges}
        />
      ) : null}
    </RichCardHeaderContainer>
  )
}
